import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'u2b-button-browser-back',
    templateUrl: './button-browser-back.component.html',
    standalone: false
})
export class ButtonBrowserBackComponent {
    @HostBinding('class') class = 'u2b-button-browser-back';
}
